"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var helpers_1 = require("@/frontend/helpers");
var Check_1 = __importDefault(require("@mui/icons-material/Check"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var material_1 = require("@mui/material");
var trans_1 = __importDefault(require("@/plugins/trans"));
var useIsMobileFullScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsMobileFullScreen"));
var useIsSmallScreen_1 = __importDefault(require("@/frontend/react/hooks/useIsSmallScreen"));
var Button_1 = __importDefault(require("@/frontend/react/Button"));
var NotificationContext_1 = __importDefault(require("@/frontend/react/context/NotificationContext"));
var classes = {
    desktop: {
        display: 'flex',
        gap: 4,
        padding: 4,
    },
    mobile: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: 4,
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
    },
    simple: {
        display: 'flex',
        justifyContent: 'space-around',
        paddingTop: 4,
    },
};
function InviteAcceptDecline(_a) {
    var invite = _a.invite, _b = _a.simple, simple = _b === void 0 ? false : _b;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var queryClient = (0, react_query_1.useQueryClient)();
    var isMobileFullScreen = (0, useIsMobileFullScreen_1.default)();
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var clearNotification = (0, react_1.useContext)(NotificationContext_1.default).clearNotification;
    var declineLabel = (0, react_1.useMemo)(function () {
        if (simple || isSmallScreen) {
            return '';
        }
        return trans_1.default.get('connections.request.deny');
    }, [simple, isSmallScreen]);
    var accept = (0, react_query_1.useMutation)(function () {
        return axios_1.default.post("/data/invites/".concat(invite.id, "/accept")).then(function (_a) {
            var data = _a.data;
            clearNotification('invitations', 121200000000 + invite.id);
            if (data.toasty) {
                (0, helpers_1.toasty)({ message: data.toasty.message, type: data.toasty.type });
            }
            if (data.conversationId) {
                navigate("/connections/chats/".concat(data.conversationId));
            }
        });
    });
    var decline = (0, react_query_1.useMutation)(function () {
        return axios_1.default.post("/data/invites/".concat(invite.id, "/decline")).then(function (_a) {
            var data = _a.data;
            if (data.toasty) {
                (0, helpers_1.toasty)({ message: data.toasty.message, type: data.toasty.type });
            }
            queryClient.invalidateQueries('invites');
            navigate('/connections/invites');
        });
    });
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: isMobileFullScreen ? classes.mobile : classes.desktop }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ endIcon: (0, jsx_runtime_1.jsx)(Check_1.default, { sx: { marginLeft: 4 } }), onClick: function (event) {
                    event.preventDefault();
                    accept.mutate();
                }, disabled: accept.isLoading || decline.isLoading }, { children: trans_1.default.get('connections.request.accept') })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ endIcon: (0, jsx_runtime_1.jsx)(Close_1.default, { sx: { marginLeft: declineLabel === '' ? 0 : 4 } }), outlined: true, onClick: function (event) {
                    event.preventDefault();
                    decline.mutate();
                }, disabled: accept.isLoading || decline.isLoading }, { children: declineLabel }))] })));
}
exports.default = InviteAcceptDecline;
